import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass"; 
import { useNavigate } from "react-router-dom";
import Allcategory from "../../data/category.json";
import slugify from "../../utils/slugify";

const GameTags = ({ tags }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  if (!Array.isArray(tags)) return null;

  const handleCategoryClick = (title) => {
    navigate(`/games/${slugify(title)}`);
  };

  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {tags.map((tag, index) => {
        const categoryDetails = Allcategory.find(
          (cat) => cat.title.trim().toLowerCase() === tag.trim().toLowerCase()
        );
        if (!categoryDetails) return null;

        return (
          <button
            key={index}
            onClick={() => handleCategoryClick(categoryDetails.title)}
            className={`
              ${themeClass.overlayBg}
              ${themeClass.baseText}
              text-sm md:text-base 
              border ${themeClass.borderColor} 
              ${themeClass.hoverBorder} hover:${themeClass.hoverAccentText}
              rounded-full px-3 py-1 
              transition duration-200 
              shadow-sm hover:shadow-md
            `}
          >
            {tag}
          </button>
        );
      })}
    </div>
  );
};

export default GameTags;
